// @ts-check
/**
 * Ustálení vstupu (ui-checklist bod 14; sekce 3 R-25 e, B1b upřesnění 18): jedna sdílená funkce
 * pro pole, která řídí dotaz (hledání zadavatelů, F2 hledání výpisu) — modul si nikdy nedrží
 * vlastní `setTimeout`.
 *
 * `settle(fn, ms, timers)` vrátí funkci, která zavolá `fn` s posledními argumenty až `ms`
 * milisekund po POSLEDNÍM volání (každé další volání čekání restartuje); `cancel()` čekání
 * zruší bez volání `fn` (odpojení modulu). Časovače jdou vstříknout (jsdom testy), výchozí
 * z `globalThis`. Žádný stav mimo uzávěr, žádné texty UI.
 */

/**
 * @typedef {object} Timers
 * @property {(fn: () => void, ms: number) => unknown} [setTimeout]
 * @property {(handle: unknown) => void} [clearTimeout]
 */

/**
 * @template {unknown[]} A
 * @param {(...args: A) => void} fn
 * @param {number} [ms]
 * @param {Timers} [timers]
 * @returns {((...args: A) => void) & { cancel: () => void }}
 */
export function settle(fn, ms = 300, timers = {}) {
  const set = timers.setTimeout ?? ((f, t) => globalThis.setTimeout(f, t));
  const clear = timers.clearTimeout ?? ((h) => globalThis.clearTimeout(/** @type {any} */ (h)));
  /** @type {unknown} */
  let handle = null;
  /** @param {A} args */
  const settled = (...args) => {
    if (handle !== null) clear(handle);
    handle = set(() => {
      handle = null;
      fn(...args);
    }, ms);
  };
  settled.cancel = () => {
    if (handle !== null) {
      clear(handle);
      handle = null;
    }
  };
  return settled;
}
